/* Holy Journey theme behaviour: menu, toggles, add-to-cart and the cart drawer. */
(function () {
  const R = window.hjRoutes || { cartAdd: "/cart/add.js", cartChange: "/cart/change.js", cart: "/cart.js", cartPage: "/cart", moneyFormat: "${{amount}}" };
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  function money(cents) {
    const n = cents / 100;
    const fmt = R.moneyFormat || "${{amount}}";
    const amount = n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDec = n.toLocaleString("en-US", { maximumFractionDigits: 0 });
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ","))
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/<[^>]*>/g, "");
  }
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  /* Price with small raised cents; matches snippets/hj-money.liquid. Screen readers get the full price.
     Digital/online items (no shipping) show plain whole dollars with no cents ($27). */
  function moneyHtml(cents, digital) {
    if (digital) {
      const plain = money(cents).replace(/\.00(?=\D*$)/, "");
      return `<span class="hj-money hj-money--digital">${esc(plain)}</span>`;
    }
    const full = money(cents);
    const m = full.match(/^(.*)\.(\d{2})(\D*)$/);
    if (!m) return `<span class="hj-money">${esc(full)}</span>`;
    return `<span class="hj-money"><span class="hj-sr">${esc(full)}</span><span class="hj-money__v" aria-hidden="true">${esc(m[1])}<span class="hj-money__c">${esc(m[2])}</span>${esc(m[3])}</span></span>`;
  }

  let toastTimer;
  function toast(msg) {
    const t = $("#hj-toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("is-on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("is-on"), 2200);
  }

  /* Mobile menu */
  $$("[data-hj-burger]").forEach((b) =>
    b.addEventListener("click", () => {
      const menu = document.getElementById(b.getAttribute("aria-controls"));
      const open = b.getAttribute("aria-expanded") !== "true";
      b.setAttribute("aria-expanded", open);
      menu && menu.classList.toggle("is-open", open);
    })
  );

  /* Segmented toggles that switch a data attribute on a target (parish billing) */
  $$("[data-hj-toggle]").forEach((group) => {
    const target = document.getElementById(group.dataset.hjToggle);
    $$("button", group).forEach((btn) =>
      btn.addEventListener("click", () => {
        $$("button", group).forEach((b) => b.setAttribute("aria-pressed", b === btn));
        if (target) target.dataset.billing = btn.dataset.value;
      })
    );
  });

  /* Variant picker: theme-filtered variants only; no catalog mutations. */
  const initializedProducts = new WeakSet();
  function setupProduct(scope) {
    if (initializedProducts.has(scope)) return;
    const dataEl = $("[data-hj-variants]", scope);
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const form = dataEl.closest("form");
    if (!form || !variants.length) return;
    initializedProducts.add(scope);
    const idInput = $('input[name="id"]', form);
    const planInput = $("[data-hj-plan]", form);
    const membership = dataEl.hasAttribute("data-hj-membership");
    const groups = $$("[data-hj-opt]", form);
    const priceEl = $("[data-hj-price]", scope);
    const imgEl = $("[data-hj-img]", scope);
    const btn = $("[data-hj-add]", form);
    let current = variants.find(v => String(v.id) === idInput.value) || variants[0];
    const chosen = () => groups.map(g => { const b = $('[aria-pressed="true"]', g); return b ? b.dataset.value : null; });
    function choose(v) {
      groups.forEach(g => $$("button[data-value]", g).forEach(b => {
        b.setAttribute("aria-pressed", String(b.dataset.value === v.options[Number(g.dataset.hjOpt)]));
      }));
    }
    function update() {
      const sel = chosen();
      const v = variants.find(x => groups.every((g, i) => x.options[Number(g.dataset.hjOpt)] === sel[i]));
      current = v || null;
      if (!v) {
        idInput.value = "";
        if (btn) { btn.disabled = true; btn.textContent = "Unavailable"; }
        return;
      }
      idInput.value = v.id;
      idInput.disabled = false;
      // Membership billing is not configured in the catalog. Do not submit a one-time charge.
      if (planInput) { planInput.value = (membership && v.plan) ? String(v.plan) : ""; planInput.disabled = !(membership && v.plan); }
      form.dataset.hjMembershipPreview = "false";
      const suffix = membership ? v.period : (priceEl && priceEl.dataset.suffix);
      if (priceEl) priceEl.innerHTML = (v.compareHtml || "") + (v.priceHtml || esc(v.price)) + (suffix ? `<small>${esc(suffix)}</small>` : "");
      if (imgEl) {
        const src = imgEl.hasAttribute("data-hj-main") ? (v.imageLg || v.image) : v.image;
        if (src) imgEl.src = src;
      }
      groups.forEach((g, gi) => $$("button", g).forEach(b => {
        const label = $("[data-hj-optprice]", b);
        if (!label) return;
        const trial = sel.slice(); trial[gi] = b.dataset.value;
        const match = variants.find(x => groups.every((gg, i) => x.options[Number(gg.dataset.hjOpt)] === trial[i]));
        if (match) { if (match.priceHtml) label.innerHTML = match.priceHtml; else label.textContent = match.price; }
      }));
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = (v.available ? btn.dataset.label : (btn.dataset.soldout || "Unavailable"));
      }
      const cover = groups.find(g => g.classList.contains("hj-swatches"));
      const activeCover = cover && $('[aria-pressed="true"]', cover);
      if (activeCover) {
        $$("[data-hj-thumb-color]", scope).forEach(t => {
          t.setAttribute("aria-pressed", String(t.dataset.hjThumbColor === activeCover.dataset.value));
        });
      }
    }
    groups.forEach(g => $$("button", g).forEach(b => b.addEventListener("click", () => {
      $$("button", g).forEach(x => x.setAttribute("aria-pressed", String(x === b)));
      update();
    })));
    scope.hjSetCover = value => {
      const cover = groups.find(g => g.classList.contains("hj-swatches"));
      const b = cover && $$("button", cover).find(x => x.dataset.value === value);
      if (b) b.click();
    };
    form.hjCanSubmit = () => current && current.available && String(current.id) === idInput.value;
    form.hjRefresh = update;
    choose(current);
    update();
  }
  $$("[data-hj-product]").forEach(setupProduct);

  /* Product gallery thumbnails */
  $$("[data-hj-gallery]").forEach((g) => {
    const main = $("[data-hj-main]", g);
    $$("[data-hj-thumb]", g).forEach((t) => t.addEventListener("click", () => {
      const product = g.closest("[data-hj-product]");
      if (t.dataset.hjThumbColor && product && product.hjSetCover) {
        product.hjSetCover(t.dataset.hjThumbColor);
        return;
      }
      $$("[data-hj-thumb]", g).forEach((x) => x.setAttribute("aria-pressed", x === t));
      if (main) main.src = t.dataset.hjThumb;
    }));
  });

  /* Product page tabs */
  $$("[data-hj-tabs]").forEach((box) => {
    $$(".hj-tab", box).forEach((t) => t.addEventListener("click", () => {
      $$(".hj-tab", box).forEach((x) => x.setAttribute("aria-selected", x === t));
      $$("[data-panel]", box).forEach((p) => { p.hidden = p.dataset.panel !== t.dataset.tab; });
    }));
  });

  /* Movement filter chips on the volume shelf */
  $$("[data-hj-chips]").forEach((g) => {
    const shelf = document.getElementById("shelf-" + g.dataset.hjChips);
    $$("button", g).forEach((b) => b.addEventListener("click", () => {
      $$("button", g).forEach((x) => x.setAttribute("aria-pressed", x === b));
      $$(".hj-vol", shelf).forEach((v) => { v.hidden = !(b.dataset.mv === "all" || v.dataset.mv === b.dataset.mv); });
    }));
  });

  /* One switch for every cover on the shelf */
  $$("[data-hj-allstyle]").forEach((g) => {
    const shelf = document.getElementById("shelf-" + g.dataset.hjAllstyle);
    $$("button", g).forEach((b) => b.addEventListener("click", () => {
      $$("button", g).forEach((x) => x.setAttribute("aria-pressed", x === b));
      $$("[data-hj-product]", shelf).forEach((p) => p.hjSetCover && p.hjSetCover(b.dataset.value));
    }));
  });

  /* Cart drawer */
  const drawer = $("#hj-drawer"), scrim = $("#hj-scrim");
  function setDrawer(open) {
    if (!drawer) { if (open) window.location.href = R.cartPage; return; }
    drawer.classList.toggle("is-on", open);
    scrim && scrim.classList.toggle("is-on", open);
    drawer.setAttribute("aria-hidden", !open);
    if (open) { const x = $(".hj-x", drawer); x && x.focus(); }
  }
  $$("[data-hj-open-cart]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); setDrawer(true); }));
  $$("[data-hj-close-cart]").forEach((b) => b.addEventListener("click", () => setDrawer(false)));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") setDrawer(false); });

  /* Optional shipping progress. It remains absent unless a verified amount and ISO currency are configured. */
  function renderShippingProgress(cart) {
    const bars = $$('[data-hj-shipping-progress]');
    if (!bars.length || !cart || !cart.items) return;
    const physicalSubtotal = cart.items.reduce((total, item) => item.requires_shipping ? total + item.final_line_price : total, 0);
    bars.forEach((bar) => {
      const threshold = Number(bar.dataset.threshold || 0);
      const expectedCurrency = (bar.dataset.currency || '').toUpperCase();
      const activeCurrency = (cart.currency || '').toUpperCase();
      if (!threshold || !expectedCurrency || expectedCurrency !== activeCurrency) {
        bar.hidden = true;
        return;
      }
      const remaining = Math.max(0, threshold - physicalSubtotal);
      const message = $('[data-hj-shipping-message]', bar);
      const fill = $('[data-hj-shipping-fill]', bar);
      bar.hidden = false;
      const template = remaining === 0 ? bar.dataset.complete : bar.dataset.remaining;
      if (message && template) message.textContent = template.replace('[amount]', money(remaining));
      if (fill) fill.style.width = Math.min(100, Math.floor((physicalSubtotal * 100) / threshold)) + '%';
    });
  }

  function renderCart(cart) {
    $$("[data-hj-count]").forEach((c) => (c.textContent = cart.item_count));
    renderShippingProgress(cart);
    const membershipPending = false;
    $$("[data-hj-checkout]").forEach(button => { button.disabled = cart.item_count === 0 || membershipPending; });
    $$("[data-hj-cart-membership-status]").forEach(note => { note.hidden = !membershipPending; });
    if (!drawer) return;
    const body = $("[data-hj-lines]", drawer);
    const sub = $("[data-hj-subtotal]", drawer);
    const checkout = $("[data-hj-checkout]", drawer);
    if (sub) sub.innerHTML = moneyHtml(cart.total_price);
    if (checkout) checkout.disabled = cart.item_count === 0 || membershipPending;
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = `<p class="hj-empty">${esc(body.dataset.empty || "Your order is empty.")}</p>`;
      return;
    }
    body.innerHTML = cart.items.map((item, i) => {
      const variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      const plan = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : "";
      const img = item.image ? `<img src="${esc(item.image)}&width=120" alt="">` : "";
      return `<div class="hj-line">
        <div class="hj-mini">${img}</div>
        <div>
          <h5><a href="${esc(item.url)}">${esc(item.product_title)}</a></h5>
          <div class="hj-line__v">${esc([variant, plan].filter(Boolean).join(" · "))}</div>
          <div class="hj-qty">
            <button type="button" data-line="${i + 1}" data-qty="${item.quantity - 1}" aria-label="Fewer">−</button>
            <span class="hj-num">${item.quantity}</span>
            <button type="button" data-line="${i + 1}" data-qty="${item.quantity + 1}" aria-label="More">+</button>
          </div>
        </div>
        <div class="hj-num">${moneyHtml(item.final_line_price, item.requires_shipping === false)}</div>
      </div>`;
    }).join("");
  }

  async function refreshCart() {
    try { const r = await fetch(R.cart, { headers: { Accept: "application/json" } }); renderCart(await r.json()); }
    catch (e) { console.error(e); }
  }

  drawer && drawer.addEventListener("click", async (e) => {
    const b = e.target.closest("[data-line]");
    if (!b) return;
    b.disabled = true;
    try {
      const r = await fetch(R.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.qty) }),
      });
      if (!r.ok) throw new Error((await r.json()).description || "Update failed");
      renderCart(await r.json());
    } catch (err) { toast(err.message); refreshCart(); }
  });

  /* Add to cart without leaving the page */
  $$("form[data-hj-form]").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = $("[data-hj-add]", form);
      if (form.dataset.hjSubmitting === "true") return;
      if (form.hjCanSubmit && !form.hjCanSubmit()) {
        toast(form.dataset.hjMembershipPreview === "true" ? "Membership checkout is not active in this preview." : "Please choose an available option.");
        return;
      }
      if (btn && btn.disabled) return;
      form.dataset.hjSubmitting = "true";
      if (btn) btn.disabled = true;
      try {
        const r = await fetch(R.cartAdd, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || data.message || "That couldn't be added.");
        /* Included item (e.g. Challenge Journal with the 7-Volume Set): one per set, made $0 by an automatic discount */
        if (form.dataset.hjInclude) {
          const q = parseInt((form.querySelector("[name=quantity]") || {}).value, 10) || 1;
          try {
            await fetch(R.cartAdd, { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: Number(form.dataset.hjInclude), quantity: q }] }) });
          } catch (_) { /* the set is already in the cart; never block on the included item */ }
        }
        toast(`${data.product_title} added`);
        if (btn) { btn.classList.add("is-done"); btn.textContent = "Added ✓"; }
        await refreshCart();
        if (form.dataset.hjForm === "open") setDrawer(true);
        setTimeout(() => {
          form.dataset.hjSubmitting = "false";
          if (btn) btn.classList.remove("is-done");
          if (form.hjRefresh) form.hjRefresh();
          else if (btn) { btn.textContent = btn.dataset.label; btn.disabled = false; }
        }, 1300);
      } catch (err) {
        toast(err.message);
        form.dataset.hjSubmitting = "false";
        if (form.hjRefresh) form.hjRefresh();
        else if (btn) btn.disabled = false;
      }
    });
  });

  /* Other scripts (apps, theme editor) can announce cart changes too */
  document.addEventListener("cart:updated", (e) => (e.detail && e.detail.items ? renderCart(e.detail) : refreshCart()));
  window.addEventListener("pageshow", (e) => { if (e.persisted) refreshCart(); });

  refreshCart();
})();
